import React from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import { brandTokens } from '../theme';
import { formatBRL } from '../utils/formatBRL';

/**
 * Shared package card used by logged-in purchase UI and Home marketing section.
 */
const PackageCard = ({ pkg, onBuy, ctaLabel = 'Comprar' }) => (
  <Box
    sx={{
      p: 2.5,
      borderRadius: 3,
      bgcolor: 'white',
      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
      borderTop: `4px solid ${brandTokens.green}`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    }}
  >
    <Typography variant="h4" sx={{ fontWeight: 700, color: brandTokens.navy }}>
      {pkg.credits_quantity}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      consultas
    </Typography>
    <Divider sx={{ width: '100%', my: 1 }} />
    <Typography variant="h6" sx={{ color: brandTokens.greenDark, fontWeight: 700, mb: 2 }}>
      {formatBRL(pkg.price_cents)}
    </Typography>
    <Button
      fullWidth
      variant="contained"
      onClick={() => onBuy(pkg)}
      sx={{
        color: '#fff',
        background: brandTokens.signatureGradient,
        borderRadius: 2,
        textTransform: 'uppercase',
        fontWeight: 600,
        boxShadow: '0 8px 24px rgba(81,223,148,0.3)',
      }}
    >
      {ctaLabel}
    </Button>
  </Box>
);

export default PackageCard;
